import React from 'react';
import { Route } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

interface DialogRouteProps {
  path?: string;
}

export const DialogRoute: React.FC<DialogRouteProps> = ({ path, children }) => (
  <Route path={path}>
    {({ match }) => (
      <CSSTransition in={!!match} timeout={300} classNames="dialog-container" unmountOnExit={true}>
        {children}
      </CSSTransition>
    )}
  </Route>
);
